const STORAGE_KEY = "onenext.demoMode.v1";
const HEADER_NAME = "X-Demo-Mode";

const subscribers = new Set<() => void>();
let cachedActive: boolean | null = null;
let cacheInitialised = false;

function readFromStorage(): boolean {
  if (typeof window === "undefined") return false;
  try {
    return window.localStorage.getItem(STORAGE_KEY) === "1";
  } catch {
    return false;
  }
}

function refreshSnapshot(): void {
  const next = readFromStorage();
  const changed = !cacheInitialised || cachedActive !== next;
  cachedActive = next;
  cacheInitialised = true;
  if (changed) subscribers.forEach((cb) => cb());
}

export function isDemoModeActive(): boolean {
  if (!cacheInitialised) refreshSnapshot();
  return cachedActive ?? false;
}

export function getDemoModeHeaders(): Record<string, string> {
  return isDemoModeActive() ? { [HEADER_NAME]: "true" } : {};
}

export function enableDemoMode(): void {
  if (typeof window === "undefined") return;
  window.localStorage.setItem(STORAGE_KEY, "1");
  cachedActive = true;
  cacheInitialised = true;
  subscribers.forEach((cb) => cb());
}

export function disableDemoMode(): void {
  if (typeof window === "undefined") return;
  window.localStorage.removeItem(STORAGE_KEY);
  cachedActive = false;
  cacheInitialised = true;
  subscribers.forEach((cb) => cb());
}

const TUTORIAL_STORAGE_KEY = "onenext.demoTutorial.step";

export function resetDemoTutorial(): void {
  try {
    window.localStorage.setItem(TUTORIAL_STORAGE_KEY, "0");
  } catch {}
}

export function subscribeDemoMode(cb: () => void): () => void {
  subscribers.add(cb);
  const onStorage = (e: StorageEvent) => {
    if (e.key === STORAGE_KEY) {
      refreshSnapshot();
      cb();
    }
  };
  if (typeof window !== "undefined") {
    window.addEventListener("storage", onStorage);
  }
  return () => {
    subscribers.delete(cb);
    if (typeof window !== "undefined") {
      window.removeEventListener("storage", onStorage);
    }
  };
}
